import { Survey } from "./survey";

export class Interaction{
    surveyId: string;
    agentId: string;//usermail
    response: Survey[];
}